import React, { useEffect, useState } from "react";
import { QrGenerate } from "../../../api/WalletApi";
import { motion } from "framer-motion";
import { Button, Avatar, Input, Spin } from "antd";
import { UserOutlined, ArrowLeftOutlined } from "@ant-design/icons";

function QrDisplay({ setView, walletDetails, userDetails }) {
  const [qrData, setQrData] = useState(null);
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [dynamicMode, setDynamicMode] = useState(false); // for input vs QR

  // Fetch static QR initially
  useEffect(() => {
    const fetchStaticQr = async () => {
      setLoading(true);
      try {
        const data = await QrGenerate({ amount: null });
        setQrData(data.data);
      } catch (err) {
        console.error("Error fetching QR:", err);
      } finally {
        setLoading(false);
      }
    };

    if (walletDetails?.staticQrCode) {
      fetchStaticQr();
    }
  }, [walletDetails]);

  // Handle dynamic QR generation
  const handleGenerateDynamicQr = async () => {
    if (!amount || isNaN(amount) || Number(amount) <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    setLoading(true);
    try {
      const data = await QrGenerate({ amount });
      setQrData(data.data);
      setDynamicMode(true); // switch to QR view
    } catch (err) {
      console.error("Error generating dynamic QR:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      key="qrpay"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -40 }}
      transition={{ duration: 0.4 }}
      style={{
        minHeight: "100vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "16px",
        overflowY: "auto", // ✅ scroll if content exceeds
      }}
    >
      {/* Header */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h3
          style={{
            flex: 1,
            textAlign: "center",
            margin: 0,
            fontWeight: 600,
            fontSize: "1.1rem",
          }}
        >
          My QR Code
        </h3>
      </div>

      {/* QR Box */}
      <div
        style={{
          background: "#fafafa",
          borderRadius: 16,
          padding: 20,
          textAlign: "center",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          width: "100%",
          maxWidth: 430,
          flexShrink: 0,
        }}
      >
        {/* Back Icon (only in dynamic QR mode) */}
        {dynamicMode && (
          <ArrowLeftOutlined
            onClick={() => {
              setDynamicMode(false);
              setQrData(null);
              setAmount("");
            }}
            style={{
              position: "absolute",
              top: 16,
              left: 16,
              fontSize: 18,
              cursor: "pointer",
              color: "#333",
            }}
          />
        )}

        <Avatar size={64} icon={<UserOutlined />} style={{ marginBottom: 8 }} />
        <p
          style={{ fontWeight: 600, marginBottom: 12, wordBreak: "break-word" }}
        >
          @{userDetails?.name || "guest"}
        </p>

        {loading ? (
          <Spin />
        ) : walletDetails?.staticQrCode ? (
          qrData && (
            <>
              <img
                src={`data:image/png;base64,${qrData.qrCode}`}
                alt="QR Code"
                style={{
                  width: "100%",
                  maxWidth: 300,
                  height: "auto",
                  marginBottom: 12,
                }}
              />
              <p style={{ fontSize: 14, color: "#444" }}>
                <strong>Account:</strong> {qrData?.accountNumber}
              </p>
            </>
          )
        ) : dynamicMode && qrData ? (
          <>
            <img
              src={`data:image/png;base64,${qrData.qrCode}`}
              alt="QR Code"
              style={{
                width: "100%",
                maxWidth: 220,
                height: "auto",
                marginBottom: 12,
              }}
            />
            <p style={{ fontSize: 14, color: "#444" }}>
              <strong>Account:</strong> {qrData?.accountNumber}
            </p>
            {amount && (
              <p style={{ fontSize: 14, color: "#444" }}>
                <strong>Amount:</strong> {amount}
              </p>
            )}
          </>
        ) : (
          <div style={{ marginTop: 16 }}>
            <Input
              placeholder="Enter amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={{ width: "100%", marginBottom: 12 }}
            />
            <Button
              type="primary"
              block
              onClick={handleGenerateDynamicQr}
              style={{ background: "#0575E6", border: "none" }}
            >
              Generate QR
            </Button>
          </div>
        )}
      </div>

      {/* Scan button */}
      <div style={{ marginTop: 32, width: "100%", maxWidth: 340 }}>
        <Button
          type="primary"
          block
          style={{
            background: "#021B79",
            border: "none",
            fontWeight: 600,
            height: 48,
          }}
          onClick={() => setView("scanner")}
        >
          Scan QR Instead
        </Button>
      </div>
    </motion.div>
  );
}

export default QrDisplay;
